import type { ReactNode } from 'react'

export type ReportColumn<T> = {
  key: string
  label: string
  align?: 'left' | 'right'
  render: (row: T) => ReactNode
}

export function ReportTable<T>({
  rows,
  columns,
  rowKey,
}: {
  rows: T[]
  columns: ReportColumn<T>[]
  rowKey: (row: T, index: number) => string
}) {
  return (
    <div className="overflow-x-auto rounded-xl border border-border bg-card">
      <table className="w-full min-w-[720px] text-sm">
        <thead className="border-b border-border bg-muted/40 text-muted-foreground">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={`px-4 py-3 font-medium ${column.align === 'right' ? 'text-right' : 'text-left'}`}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {rows.map((row, index) => (
            <tr key={rowKey(row, index)} className="transition-colors hover:bg-muted/30">
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`px-4 py-3 text-foreground ${column.align === 'right' ? 'text-right tabular-nums' : 'text-left'}`}
                >
                  {column.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
